var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 6,
    viewBox: "0 0 141 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0141602 0.718589C0.0141602 0.718589 2.06488 2.8509 5.10529 6H135.581C137.727 3.77391 138.526 2.94468 140.672 0.718589H0.0141602Z",
    fill: "url(#paint0_linear_4344_331553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4344_331553",
    x1: 70.3431,
    y1: 6,
    x2: 70.3431,
    y2: 0.718589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13586B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyan);
export default __webpack_public_path__ + "static/media/cyan.59712156e8d00083d8e1cefc53a4bf4d.svg";
export { ForwardRef as ReactComponent };